import { Tag, Text } from '@digibee/beehive-ui';

import * as Elements from './EnvironmentDeployedVersion.elements';
import BadgeLoading from '../BadgeLoading';

import i18n from '~/common/helpers/i18n';

const EnvironmentDeployedVersion = ({
  deployPipelineIds,
  deployPipelineById,
  loading
}) => (
  <Elements.Container>
    <Text variant='b2'>{i18n.t('label.current_deployed_versions')}</Text>
    {loading && <BadgeLoading itemsProps={2} />}
    {!loading && (
      <Elements.WrapperBadge>
        {deployPipelineIds?.map(item => (
          <Tag variant='neutral' data-testid='build-deploy-tag-version'>
            {`${deployPipelineById[item].environment} ${deployPipelineById[item].versionMajor}.${deployPipelineById[item].versionMinor}`}
          </Tag>
        ))}
        {!deployPipelineIds.length && (
          <Tag variant='neutral' data-testid='build-deploy-tag-version'>
            {i18n.t('label.nothing_deployed')}
          </Tag>
        )}
      </Elements.WrapperBadge>
    )}
  </Elements.Container>
);

export default EnvironmentDeployedVersion;
